module.exports = __webpack_public_path__ + "assets/img/jd.90f72266.png";